<template>
  <div id="app">
    <component :is="layout">
      <router-view :key="$route.fullPath" />
    </component>
  </div>
</template>

<script>
const defaultLayout = "default";
import { mapActions } from "vuex";

export default {
  metaInfo() {
    return {
      title: "Thi thử HSK online, nền tảng thi thử hsk 1,2,3,4,5,6 miễn phí",
      titleTemplate: "%s | HSK Online",
      meta: [
        { charset: "utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
        { vmid: 'robots', name: 'robots', content: "index, follow" },
        // OPG
        { property: 'og:title', content: 'Thi thử HSK online, nền tảng thi thử hsk 1,2,3,4,5,6 miễn phí' },
        { property: 'og:site_name', content: 'Luyện thi HSK Online' },
        { property: 'og:keyword', content: 'thi thu hsk, de thi hsk, thi thu hsk online, thi thử hsk trực tuyến' },
        { property: 'og:locale', content: 'vi_VN' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: `${process.env.BASE_URL}` },
        { property: 'og:description', content: 'Nền tảng thi thử HSK online miễn phí đầu tiên tại Việt Nam, đề thi test hsk trực tuyến chất lượng từ đội ngũ giảng viên giàu kinh nghiệm luyện thi HSK.' },
        { property: 'og:image', content: 'https://tryhsk.com/uploads/articles/2020/03/18/5e71d24681a3d3339571.jpg' },
        { property: 'og:image:width', content: '900' },
        { property: 'og:image:height', content: '258' },
        { property: 'twitter:card', content: 'summary_large_image' },
        { property: 'twitter:description', content: 'Nền tảng thi thử HSK online miễn phí đầu tiên tại Việt Nam, đề thi test hsk trực tuyến chất lượng từ đội ngũ giảng viên giàu kinh nghiệm luyện thi HSK.' },
        { property: 'twitter:title', content: 'Luyện thi HSK Online uy tín nhất Việt Nam' },
        { property: 'twitter:image', content: 'https://tryhsk.com/uploads/articles/2020/03/18/5e71d24681a3d3339571.jpg' },
      ],
      link: [
        { rel: 'canonical', href: `${process.env.BASE_URL}` }
      ]
    }
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || defaultLayout) + "-layout";
    }
  },
  mounted() {
    this.authInfo();
  },
  methods: {
    ...mapActions("auth", ["authInfo"])
  }
};
</script>

<style lang="scss">
@import "./assets/scss/styles.scss";
</style>
